import React from 'react';
import useForecast from '../../hooks/useForecast';
import useTriggerLevels from '../../hooks/useTriggerLevels';
import PlotForecast from './PlotForecast';

export default function Plot({
  stateSchema,
  locationIDs,
  theme,
  forecastPubTime
}) {
  const { forecastShort, forecastMedium } = useForecast({
    stateSchema,
    locationIDs,
    forecastPubTime
  });

  /* eslint-disable no-unused-vars */
  const { triggerLevels, lonLat, publicNote } = useTriggerLevels({
    stateSchema,
    locationIDs
  });
  /* eslint-disable no-unused-vars */
  // TODO rename var locationIDs, it is a single location, not plural
  if (stateSchema && locationIDs) {
    if (forecastShort && forecastMedium && triggerLevels) {
      return (
        <PlotForecast
          locationIDs={locationIDs}
          forecastShort={forecastShort}
          forecastMedium={forecastMedium}
          triggerLevels={triggerLevels}
          theme={theme}
        />
      );
    } else {
      return (
        <div className='plot-fetching' style={{ marginTop: '40px' }}>
          Fetching plot data...
        </div>
      );
    }
  }
  return (
    <div className='plot' style={{ marginTop: '40px' }}>
      Please select a location from the map to view current forecast.
    </div>
  );
}
